import script from "./categorySelect.vue?vue&type=script&setup=true&lang=js"
export * from "./categorySelect.vue?vue&type=script&setup=true&lang=js"

import "./categorySelect.vue?vue&type=style&index=0&id=042d1bb4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-042d1bb4"]])

export default __exports__